import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { Label, PrimaryButton, TextField } from '../default'

import { rCNPJ, rEMAIL } from '../../class/utils'

function CardSearchEmailCnpj({
  classes, onSearch, title, caption
}) {
  const { t } = useTranslation()

  const [emailCnpj, setEmailCnpj] = useState('')

  const [validationError, setValidationError] = useState(null)

  const validateField = event => {
    let value = event.target.value
    setEmailCnpj(value)

    const isEmail = value.match(rEMAIL)
    const isCnpj = value.match(rCNPJ)

    if (!isEmail && !isCnpj) {
      setValidationError(t('cards.block.errors.invalidField'))
    } else {
      setValidationError(null)
    }
  }

  const validateAllBeforeSearch = () => {
    if (validationError) {
      return
    }

    if (!emailCnpj) {
      return setValidationError(t('cards.block.errors.insertValue'))
    }

    setValidationError(null)

    return onSearch(emailCnpj)
  }

  const renderField = () => {
    return (
      <TextField
        className={classes.formField}
        style={{ width: '100%', height: '100%', marginTop: 0, marginBottom: 0 }}
        label={'Email/CNPJ'}
        placeholder={'Digite um email ou CNPJ'}
        value={emailCnpj}
        onChange={validateField}
        error={validationError ? true : false}
        helperText={validationError}
        type='text'
      />
    )
  }

  return (
    <Grid container item xs={12} md={8} lg={6} xl={4} spacing={1}>
      <Grid item xs={12}>
        <CardPaper>
          <div className={classes.header}>
            <Label v='h6' bold>
              {title}
            </Label>
            {
              caption &&
              <Label>
                {caption}
              </Label>
            }
          </div>
          <div className={classes.form}>
            <Grid container item xs={12} spacing={1}>
              <Grid item md={12} xs={12}>
                {renderField()}
              </Grid>
              <Grid item xs={12}>
                <PrimaryButton
                  className={classes.formField}
                  onClick={validateAllBeforeSearch}
                  style={{ width: '100%', height: '100%' }}
                >
                  {t('cards.search.btn')}
                </PrimaryButton>
              </Grid>
            </Grid>
          </div>
        </CardPaper>
      </Grid>
    </Grid>
  )
}

CardSearchEmailCnpj.propTypes = {
  onSearch: PropTypes.func,
}

CardSearchEmailCnpj.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  header: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(4)
  }
})

export default withStyles(styles)(CardSearchEmailCnpj)